import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'
import { IServiceProgramObject } from '../../types/service-program'

interface IServiceProgramRemoveModalProps {
  serviceProgram: IServiceProgramObject
  error: string
  onRemove: (id: string) => Promise<void>
  routeProps: RouteComponentProps<any>
}

export default class ServiceProgramRemoveModal extends React.Component<IServiceProgramRemoveModalProps> {
  public render() {
    const { serviceProgram, error } = this.props

    if (!serviceProgram) {
      return null
    }

    return (
      <SettingRemoveModal
        setting={{ label: serviceProgram.name, id: serviceProgram.id }}
        settingType='Service Program'
        error={error}
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    this.props.onRemove(this.props.serviceProgram.id).then(() => {
      this.props.routeProps.history.push('/global-settings/service-program')
    })
  }

  private onClose = () => {
    this.props.routeProps.history.push('/global-settings/service-program')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ServiceProgramRemoveModal.tsx